export default [
    {
        name: 'updateGlobalConfig',
        url: '/update'
    },
    {
        name: 'fetchGlobalConfig',
        url: '/detail'
    }
];
